module.exports = __webpack_public_path__ + "img/amazon.0a3ff55d.png";